import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule } from '@backbase/foundation-ang/core';
import { AccountDetailsWidgetExtendedComponent } from './account-details-widget-extended.component';
import { ProductSummaryDetailsWidgetModule } from '@backbase/retail-ang/product-summary';
import { BnAccountDetailBaseComponent } from './account-detail-base/account-detail-base.component';
import { PaymentCardModule } from '@backbase/ui-ang';
import { BnAccountDetailCreditCardComponent } from './account-detail-credit-card/account-detail-credit-card.component';
import { BnAccountDetailsCurrentComponent } from './account-details-current/account-details-current.component';
import { BnAccountDetailsCertificatesDepositComponent } from './account-details-certificates-deposit/account-details-certificates-deposit.component';
import { BnAccountDetailsLoansComponent } from './account-details-loans/account-details-loans.component';
import { BnAccountDetailCreditCardMultiComponent } from './account-details-credit-card-multi/account-detail-credit-card-multi.component';
import { BnSemaphoreTooltipModule } from 'bn-semaphore-tooltip';
import { BnCurrencyPipeModule } from 'bn-currency-pipe';
import { BnEmptyPipeModule } from 'bn-empty-pipe';
import { BnEsDatePipeModule } from 'bn-es-date-pipe';
import { BnDigitPipe } from './pipes/bn-digit.pipe';
import { BnEsDatePipe } from '../lib/pipes/bn-es-date-pipe/bn-es-date.pipe';


@NgModule({
  declarations: [
    AccountDetailsWidgetExtendedComponent,
    BnAccountDetailBaseComponent,
    BnAccountDetailCreditCardComponent,
    BnAccountDetailCreditCardMultiComponent,
    BnAccountDetailsCurrentComponent,
    BnAccountDetailsCertificatesDepositComponent,
    BnAccountDetailsLoansComponent,
    BnDigitPipe,BnEsDatePipe,
  ],
  imports: [
    CommonModule,
    PaymentCardModule,
    ProductSummaryDetailsWidgetModule,
    BnSemaphoreTooltipModule,
    BnCurrencyPipeModule,
    BnEmptyPipeModule,
    BnEsDatePipeModule,
    BackbaseCoreModule.withConfig({
      classMap: { AccountDetailsWidgetExtendedComponent },
    }),
  ],
  exports: [AccountDetailsWidgetExtendedComponent,BnAccountDetailsLoansComponent]
})
export class AccountDetailsWidgetExtendedModule {}
